import { render, staticRenderFns } from "./activityCOPSOMapping.html?vue&type=template&id=0729f4d2&scoped=true&external"
import script from "./activityCOPSOMapping.vue?vue&type=script&lang=js"
export * from "./activityCOPSOMapping.vue?vue&type=script&lang=js"
import style0 from "./activityCOPSOMapping.css?vue&type=style&index=0&id=0729f4d2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729f4d2",
  null
  
)

export default component.exports